
import { useQuery } from 'react-query';
import { getSalesforceLead } from './queries';

export const useSalesforceLead = (leadID: string) => {
  return useQuery(
    ['salesforce-lead-progress', leadID],
    () => getSalesforceLead(leadID),
    {
      enabled: !!leadID,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    }
  );
};
